import {
	listTransaksiKonsumen,
	infoTransaksiKonsumen,
	detailTransaksi,
	detailLayananTransaksi,
	statusTransaksi,
	detailPengantaranExtra,
	pagination,
	search
} from "./state"

const mutations = {
	setListTransaksiKonsumen: (state, res) => {
		if (state.listTransaksiKonsumen.data !== undefined) {
			state.listTransaksiKonsumen.data = [...state.listTransaksiKonsumen.data, ...res.data];
		} else {
			state.listTransaksiKonsumen = res
		}
	},
	setInfoTransaksiKonsumen: (state, res) => {
		state.infoTransaksiKonsumen = res
	},
	setDetailTransaksi: (state, res) => {
		state.detailTransaksi = res
	},
	setDetailLayananTransaksi: (state, res) => {
		state.detailLayananTransaksi = res
	},
	setStatusTransaksi: (state, res) => {
		state.statusTransaksi = res
	},
	setDetailPengantaranExtra: (state, res) => {
		state.detailPengantaranExtra = res
	},

	resetListTransaksiKonsumen: (state) => {
		state.listTransaksiKonsumen = listTransaksiKonsumen()
	},
	resetInfoTransaksiKonsumen: (state) => {
		state.infoTransaksiKonsumen = infoTransaksiKonsumen()
	},
	resetDetailTransaksi: (state) => {
		state.detailTransaksi = detailTransaksi()
	},
	resetDetailLayananTransaksi: (state) => {
		state.detailLayananTransaksi = detailLayananTransaksi()
	},
	resetStatusTransaksi: (state) => {
		state.statusTransaksi = statusTransaksi()
	},
	resetDetailPengantaranExtra: (state) => {
		state.detailPengantaranExtra = detailPengantaranExtra()
	},

	// search
	setSearch: (state, search) => {
		state.search.key = search;
	},
	resetSearch: (state) => {
		state.search = search();
	},
	setIsSearch: (state, bool) => {
		state.isSearch = bool
	},

	// pagination
	setNextPagination: (state, payload) => {
		state.pagination.length = payload.data.length
		state.pagination.pageNumber++
		state.pagination.offset = state.pagination.pageNumber * state.pagination.limit
	},
	resetPagination: (state, e) => {
		state.pagination = pagination()
	},

	setScrollPosition: (state, positionY) => {
		state.scrollPosition = positionY - 100
	}
}

export default mutations